import React from "react";
import cookieStorage from "../../utils/cookieStorage";
import { useNavigate } from "react-router-dom";

export default function GoForTest({ setInitSettings, initSettings }) {
  const navigate = useNavigate();

  const handleSkip = () => {
    const today = new Date().toISOString().split("T")[0];
    cookieStorage.setItem("testSkipped", today, 1);
    setInitSettings((old) => ({ ...old, isExam: false }));
  };

  const handleAttempt = () => {
    navigate(`/examination/start/${initSettings.examination._id}`);
  };

  return (
    <div className="test-card">
      <h3 className="test-title">You have a pending test</h3>
      <p className="test-message">
        Please read the instructions carefully before attempting the exam.
      </p>

      <div className="text-start">
        <h3 className="test-title">📌 Instructions:</h3>
        <ul>
          <li>❌ Do not refresh or reload the page during the test.</li>
          <li>❌ Do not press the back button in your browser.</li>
          <li>❌ Do not close the browser or tab until you submit.</li>

          <li>
            ❌ Do not open new tabs, windows, or applications during the exam.
          </li>
          <li>
            ❌ Do not use keyboard shortcuts like <b>Ctrl+R</b>, <b>Ctrl+F5</b>,
            or <b>Alt+Tab</b>.
          </li>
          <li>
            ✅ Always press the <b>Save</b> button after answering each
            question, otherwise your answer will not be saved.
          </li>
          <li>✅ Submit your exam before the timer ends.</li>
          <li>✅ Read each question carefully before answering.</li>
        </ul>
      </div>

      <div className="test-actions">
        <button className="btn btn-primary" onClick={handleAttempt}>
          Attempt Test
        </button>
        <button className="btn btn-secondary" onClick={handleSkip}>
          Skip for Now
        </button>
      </div>
    </div>
  );
}
